import React, { useState, useEffect } from "react";


import api from "../api/axiosInstance";
const ServerIntelligence = () => {
    const [logs, setLogs] = useState([]);
    const [metrics, setMetrics] = useState({ avg_time: 0, error_rate: 0 });

    useEffect(() => {
        api.post("get_server_logs.php").then(res => {
            console.log(res.data);
            setLogs(res.data.logs || []);
            setMetrics(res.data.metrics);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    return (
        <div className="p-8 space-y-8 bg-slate-900 min-h-screen text-slate-300">
            {/* Header */}
            <div className="flex justify-between items-center">
                <div>
                    <h1 className="text-3xl font-black italic uppercase tracking-tighter text-white">Server Intelligence</h1>
                    <p className="text-[10px] font-black uppercase text-indigo-400 tracking-widest">Real-time API Traffic & Performance</p>
                </div>
                <div className="flex gap-4">
                    <div className="bg-white/5 border border-white/10 p-4 rounded-3xl text-center min-w-[120px]">
                        <p className="text-[9px] font-black uppercase text-slate-500">Avg Response</p>
                        <p className="text-xl font-black text-emerald-400">{metrics.avg_time}s</p>
                    </div>
                    <div className="bg-white/5 border border-white/10 p-4 rounded-3xl text-center min-w-[120px]">
                        <p className="text-[9px] font-black uppercase text-slate-500">Error Rate</p>
                        <p className="text-xl font-black text-rose-400">{metrics.error_rate}%</p>
                    </div>
                </div>
            </div>

            {/* Live Terminal Feed */}
            <div className="bg-black/40 border border-white/10 rounded-[40px] overflow-hidden backdrop-blur-md">
                <div className="bg-white/5 p-4 border-b border-white/10 flex items-center gap-2">
                    <div className="flex gap-1.5">
                        <div className="w-2.5 h-2.5 rounded-full bg-rose-500"></div>
                        <div className="w-2.5 h-2.5 rounded-full bg-amber-500"></div>
                        <div className="w-2.5 h-2.5 rounded-full bg-emerald-500"></div>
                    </div>
                    <span className="text-[10px] font-black uppercase tracking-widest ml-4 text-slate-500">access_log_stream</span>
                </div>
                <div className="p-4 overflow-x-auto">
                    <table className="w-full text-left font-mono text-[11px]">
                        <thead>
                            <tr className="text-slate-500 border-b border-white/5 uppercase">
                                <th className="p-3">Method</th>
                                <th className="p-3">Endpoint</th>
                                <th className="p-3 text-center">Status</th>
                                <th className="p-3 text-right">Time</th>
                                <th className="p-3 text-right">Timestamp</th>
                            </tr>
                        </thead>
                        <tbody>
                            {logs.map((log) => (
                                <tr key={log.id} className="border-b border-white/5 hover:bg-white/5 transition-all group">
                                    <td className="p-3 font-black text-indigo-400">{log.method}</td>
                                    <td className="p-3 text-slate-300 max-w-xs truncate">{log.endpoint}</td>
                                    <td className="p-3 text-center">
                                        <span className={`px-2 py-0.5 rounded ${log.status_code >= 400 ? 'bg-rose-500/20 text-rose-400' : 'bg-emerald-500/20 text-emerald-400'
                                            }`}>
                                            {log.status_code}
                                        </span>
                                    </td>
                                    <td className="p-3 text-right text-slate-500">{log.execution_time}s</td>
                                    <td className="p-3 text-right text-slate-600">{new Date(log.created_at).toLocaleTimeString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ServerIntelligence;